import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 9,
    borderRadius: '0 5px 5px 0',
    height: '100%',
    maxHeight: '100%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
  },
  subHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5em',
    borderBottom: `1px solid ${theme.palette.divider}`,
    gap: 10,
  },
  leftHeader: {
    padding: '10px 15px',
  },
  iconBack: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: theme.palette.background.paper,
  },
  metricContent: {
    width: '30%',
    '@media (min-width: 1441px)': {
      width: 'max-content',
    },
  },
  protocolInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    padding: '0 0.5em',
  },
  leftContent: {
    padding: 15,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  rightHeader: {
    padding: '0 15px',
  },
  rightContent: {
    height: '100%',
    overflowY: 'auto',
    zIndex: 9,
    maxHeight: '100%',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
}))

export default useStyles
